import { useHistory, useParams } from 'react-router-dom';
import React, { useContext, useEffect, useState } from 'react';
import { CooperativaDTO, PageMode, PuntoServizioDTO, UnificazioneAslDTO, UserDTO, UserRole, UserRolePrettyName } from '../common/Dtos';
import { SButton, SButtonContainer, SCheckbox, SDialogButton, SInputLabel, SPanelContainer, STitleContainer, STitleH3, STitleH4 } from '../common/BCommonComponents';
import { FormControl, Grid, MenuItem, Select, Table, TableBody, TableContainer, TextField } from '@material-ui/core';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { toast } from 'react-toastify';
import AuthContext from '../auth/AuthContext';
import { RiAddFill } from 'react-icons/ri';
import { FaChevronLeft, FaTrash } from 'react-icons/all';
import { PuntiServizioHeadCell, PuntiServizioTableHeader } from '../puntiServizio/PuntiServizio';
import { Order, STableCell, STableRow } from '../common/ScrivaniaTable';
import { InserimentoPuntiServizioDialog } from './InserimentoPuntiServizioDialog';
import ConfirmAlertDialog from '../common/ConfirmDialogComponents';
import { getRolesPrettyName } from '../common/RoleUtils';
import { AlertDialogContext } from '../common/AlertDialog';
import { CambioPasswordDialog } from '../CambioPasswordDialog';

type DettaglioOperatoreParameters = {
	id?: string
}

export function DettaglioOperatore() {
	const auth = useContext(AuthContext);
	const alert = React.useContext(AlertDialogContext);
	const history = useHistory();
	const useStyles = makeStyles((theme: Theme) =>
		createStyles({
			formControl: {
				// margin: theme.spacing(1),
				width: '100%',
			},
			selectEmpty: {
				width: '100%',
				margin: '0',
			},
		}),
	);
	const classes = useStyles();

	const param = useParams<DettaglioOperatoreParameters>();
	const [mode, setMode] = useState(param.id ? PageMode.EDIT : PageMode.NEW);
	const [errorLogin, setErrorLogin] = useState<boolean>(false);
	const [errorFistName, setErrorFistName] = useState<boolean>(false);
	const [errorLastName, setErrorLastName] = useState<boolean>(false);
	const [errorAuth, setErrorAuth] = useState<boolean>(false);
	const [errorPass, setErrorPass] = useState<boolean>(false);
	const [errorValidEmail, setErrorValidEmail] = useState<boolean>(false);
	const [errorRepeat, setErrorRepeat] = useState<boolean>(false);
	const [errorDuplicatedLogin, setErrorDuplicatedLogin] = useState<boolean>(false);
	const [errorCodiceFiscale, setErrorCodiceFiscale] = useState<boolean>(false);
	const [cooperativeList, setCooperativeList] = useState<CooperativaDTO[]>([]);
	const [unificazioneAslList, setUnificazioneAslList] = useState<UnificazioneAslDTO[]>([]);
	const [errorCupUnico, setErrorCupUnico] = useState<boolean>(false);
	const [errorEmail, setErrorEmail] = useState<boolean>(false);

	const [puntiServizioList, setPuntiServizioList] = useState<PuntoServizioDTO[]>([]);
	const [password, setPassword] = useState<string>('');
	const [repeatNewPassword, setRepeatNewPassword] = useState<string>('');
	const [selected, setSelected] = React.useState<string[]>([]);
	const [order, setOrder] = React.useState<Order>('asc');
	const [orderBy, setOrderBy] = React.useState<keyof PuntoServizioDTO>('name');
	const [filteredPuntiServizioList, setFilteredPuntiServizioList] = useState<PuntoServizioDTO[]>([]);
	const [openCambioPassword, setOpenCambioPassword] = useState<boolean>(false);

	const [openDialogPunti, setOpenDialogPunti] = useState<boolean>(false);
	const [deleteModalVisible, setDeleteModalVisible] = useState(false);
	const [deleteUserModalVisible, setUserDeleteModalVisible] = useState(false);
	const [isDelete, setIsDelete] = useState<boolean>(false);
	const [modalMessage, setModalMessage] = useState<string>('');

	const [originalOperatore, setOriginalOperatore] = useState<UserDTO>({
		id: '',
		login: '',
		email: '',
		firstname: '',
		lastname: '',
		cooperativa: '',
		authorities: [],
		createdBy: '',
		createdDate: '',
		lastModifiedBy: '',
		lastModifiedDate: '',
		telefono: '',
		indirizzo: '',
		activated: true,
		cooperativaName: '',
		codiceFiscale: '',
		unificazioneAsl: ''
	});
	const [operatore, setOperatore] = useState<UserDTO>({
		id: '',
		login: '',
		email: '',
		firstname: '',
		lastname: '',
		cooperativa: '',
		authorities: [],
		createdBy: '',
		createdDate: '',
		lastModifiedBy: '',
		lastModifiedDate: '',
		telefono: '',
		indirizzo: '',
		activated: true,
		cooperativaName: '',
		codiceFiscale: '',
		unificazioneAsl: ''
	});

	const headCells: PuntiServizioHeadCell[] = [
		{id: 'name', numeric: false, disablePadding: true, label: 'NOME', sortable: true},
		{id: 'cooperativa', numeric: false, disablePadding: true, label: 'COOPERATIVA', sortable: true},
		{id: 'asl', numeric: false, disablePadding: true, label: 'ASL DI COMPETENZA', sortable: true},
		{id: 'indirizzo', numeric: false, disablePadding: true, label: 'INDIRIZZO', sortable: true},
		{id: 'operatori', numeric: false, disablePadding: true, label: 'N. OPERATORI ASSOCIATI', sortable: true}
	];

	useEffect(() => {

		if (auth.state.roles && auth.state.roles.indexOf(UserRole.ADMIN) >= 0) {
			getCooperative();
		}


		if (auth.state.roles && auth.state.roles.indexOf(UserRole.ADMIN) >= 0) {
			getUnificazioneAslList();
		}

		if (param.id) {
			getOperatore();
			getPuntiServizio(param.id);
		}
	}, []);

	useEffect(() => {

	}, [operatore, puntiServizioList, orderBy, order, filteredPuntiServizioList]);

	const getOperatore = () => {
		auth.state.axiosInstance?.get('/api/accounts/' + param.id)
			.then(res => {
				setOperatore(res.data);
				setOriginalOperatore(res.data);
			})
			.catch(error => {
				toast.error('🛑 Errore durante il recupero dell\'Operatore!');
				console.log(error);
			});
	}

	const getPuntiServizio = (idOperatore: string) => {
		auth.state.axiosInstance?.get('/api/puntoServizio/punti_servizio_of_operatore/' + idOperatore)
			.then(res => {
				setPuntiServizioList(res.data);
				setFilteredPuntiServizioList(res.data);
			})
			.catch(error => {
				toast.error('🛑 Errore durante il recupero dei Punti di Servizio!');
				console.log(error);
			});
	}

	const getCooperative = () => {
		if (auth.state.roles && auth.state.roles.indexOf(UserRole.ADMIN) >= 0) {
			auth.state.axiosInstance?.get('/api/cooperativa/listall')
				.then(res => {
					setCooperativeList(res.data)
				})
				.catch(error => {
					toast.error('🛑 Errore durante il recupero delle Prestazioni!');
					console.log(error);
				})
		}
	}

	const getUnificazioneAslList = () => {
		if (auth.state.roles && auth.state.roles.indexOf(UserRole.ADMIN) >= 0
			|| auth.state.roles && auth.state.roles.indexOf(UserRole.SUPERVISOR) >= 0
			|| auth.state.roles && auth.state.roles.indexOf(UserRole.RESPONSIBLE) >= 0) {
			auth.state.axiosInstance?.get('/api/unificatore-asl/all')
				.then(res => {
					setUnificazioneAslList(res.data)
				})
				.catch(error => {
					toast.error('🛑 Errore durante il recupero delle Prestazioni!');
					console.log(error);
				})
		}
	}

	const handleNomeChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		const newOp = {
			...operatore,
			firstname: event.target.value
		}

		setOperatore(newOp);
	};

	const handleCognomeChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		const newOp = {
			...operatore,
			lastname: event.target.value
		}

		setOperatore(newOp);
	};

	const handleLoginChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		const newOp = {
			...operatore,
			login: event.target.value
		}

		setOperatore(newOp);

		if (event.target.value !== originalOperatore.login) {
			auth.state.axiosInstance?.get('/api/accounts/login_exist', {
				params: {
					login: event.target.value
				}
			})
				.then(res => {
					setErrorDuplicatedLogin(res.data);
				})
				.catch(error => {
					toast.error('🛑 Errore durante il recupero dell\'Operatore!');
					console.log(error);
				});
		}
	};

	const handleTelefonoChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		const newOp = {
			...operatore,
			telefono: event.target.value
		}

		setOperatore(newOp);
	};

	const handleEmailChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		const newOp = {
			...operatore,
			email: event.target.value
		}

		setOperatore(newOp);
		/*
				if (event.target.value !== originalOperatore.email) {
					auth.state.axiosInstance?.get('/api/accounts/email_exist', {
						params: {
							email: event.target.value
						}
					})
						.then(res => {
							setErrorDuplicatedEmail(res.data);
						})
						.catch(error => {
							toast.error('🛑 Errore durante il recupero dell\'Operatore!');
							console.log(error);
						});
				}*/
	};

	const handleIndirizzoChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		const newOp = {
			...operatore,
			indirizzo: event.target.value
		}

		setOperatore(newOp);
	};

	const handleRuoloChange = (event: React.ChangeEvent<{ value: unknown }>) => {
		const newOp = {
			...operatore,
			authorities: event.target.value as string[]
		}

		setOperatore(newOp);
	};

	const handleCooperativaChange = (event: React.ChangeEvent<{ value: unknown }>) => {
		const newOp = {
			...operatore,
			cooperativa: event.target.value as string
		}

		setOperatore(newOp);
	};

	const handleUnificazioneAslChange = (event: React.ChangeEvent<{ value: unknown }>) => {
		const newOp = {
			...operatore,
			unificazioneAsl: event.target.value as string
		}

		setOperatore(newOp);
	};

	const handleCodiceFiscaleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		const newOp = {
			...operatore,
			codiceFiscale: event.target.value !== '' ? event.target.value.toUpperCase() : '',
		}

		setOperatore(newOp);
	};

	const handlePasswordChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		setPassword(event.target.value);
	}

	const handleRepeatPasswordChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		setRepeatNewPassword(event.target.value);
	}

	const handleSaveOperatore = () => {
		const regexCF = /^([A-Z]{6}[0-9LMNPQRSTUV]{2}[ABCDEHLMPRST]{1}[0-9LMNPQRSTUV]{2}[A-Z]{1}[0-9LMNPQRSTUV]{3}[A-Z]{1})$|([0-9]{11})$/;
		// const isOperatore = operatore.authorities && operatore.authorities.indexOf(UserRole.OPERATOR) >= 0;
		const codiceFiscaleRequired = operatore.authorities && (operatore.authorities.indexOf(UserRole.OPERATOR) >= 0
			|| operatore.authorities.indexOf(UserRole.RESPONSIBLE) >= 0 || operatore.authorities.indexOf(UserRole.SUPERVISOR) >= 0);
		const cupUnicoRequired = operatore.authorities && operatore.authorities.indexOf(UserRole.UNIFICATORE) >= 0

		if (operatore.login === ''
			|| operatore.firstname === ''
			|| operatore.lastname === ''
			|| (codiceFiscaleRequired && operatore.codiceFiscale === '')
			|| operatore.authorities.length === 0
			|| !operatore.login
			|| !operatore.firstname
			|| !operatore.lastname
			|| !operatore.email
			|| operatore.email === ''
			|| (codiceFiscaleRequired && !operatore.codiceFiscale)
			|| (mode === PageMode.NEW && password === '')
			|| (mode === PageMode.NEW && (repeatNewPassword === '' || password !== repeatNewPassword))
			|| (operatore.email && operatore.email !== '' && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(operatore.email))
			|| (codiceFiscaleRequired && operatore.codiceFiscale && operatore.codiceFiscale !== '' && !regexCF.test(operatore.codiceFiscale))
			|| (cupUnicoRequired && (!operatore.unificazioneAsl || operatore.unificazioneAsl === ''))) {
			setErrorAuth(operatore.authorities.length === 0);
			setErrorFistName(!operatore.firstname || operatore.firstname === '');
			setErrorLastName(!operatore.lastname || operatore.lastname === '');
			setErrorLogin(!operatore.login || operatore.login === '');
			setErrorPass(password === '');
			setErrorRepeat(repeatNewPassword === '' || password !== repeatNewPassword);
			setErrorEmail(!operatore.email || operatore.email === '');
			setErrorValidEmail(operatore.email !== null && operatore.email !== '' && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(operatore.email))
			setErrorCodiceFiscale(codiceFiscaleRequired && ((operatore.codiceFiscale !== '' && !regexCF.test(operatore.codiceFiscale)) || !operatore.codiceFiscale || operatore.codiceFiscale === ''));
			setErrorCupUnico(cupUnicoRequired && (!operatore.unificazioneAsl || operatore.unificazioneAsl === ''));
		} else {
			setErrorAuth(false);
			setErrorFistName(false);
			setErrorLastName(false);
			setErrorLogin(false);
			setErrorPass(false);
			setErrorValidEmail(false)
			setErrorRepeat(false);
			setErrorCodiceFiscale(false);
			setErrorCupUnico(false);
			setErrorEmail(false);

			if (mode === PageMode.NEW) {
				const encodedPsw = btoa(password);
				auth.state.axiosInstance?.post('/api/accounts/insert',
					{
						id: operatore.id,
						login: operatore.login,
						email: operatore.email,
						firstname: operatore.firstname,
						lastname: operatore.lastname,
						cooperativa: (operatore.cooperativa && operatore.cooperativa !== '') ? operatore.cooperativa : auth.state.cooperativa,
						authorities: operatore.authorities,
						createdBy: operatore.createdBy,
						createdDate: operatore.createdDate,
						lastModifiedBy: operatore.lastModifiedBy,
						lastModifiedDate: operatore.lastModifiedDate,
						telefono: operatore.telefono,
						indirizzo: operatore.indirizzo,
						password: encodedPsw,
						prestazioniPreferitePuntoList: [],
						cooperativaName: operatore.cooperativaName,
						codiceFiscale: operatore.codiceFiscale,
						unificazioneAsl: operatore.unificazioneAsl
					})
					.then(res => {
						toast.success('Nuovo operatore creato con successo!');

						setMode(PageMode.EDIT);
						setOperatore(res.data);
						setOriginalOperatore(res.data);
						getPuntiServizio(res.data.id)
						history.push("/dettaglio/operatore/" + res.data.id);
					})
					.catch(error => {
						toast.error('🛑 Errore durante il salvataggio dell\'operatore');
						console.log(error)
					})
			} else {
				auth.state.axiosInstance?.put('/api/accounts/update/' + operatore.id,
					{
						id: operatore.id,
						login: operatore.login,
						email: operatore.email,
						firstname: operatore.firstname,
						lastname: operatore.lastname,
						cooperativa: (operatore.cooperativa && operatore.cooperativa !== '') ? operatore.cooperativa : auth.state.cooperativa,
						authorities: operatore.authorities,
						createdBy: operatore.createdBy,
						createdDate: operatore.createdDate,
						lastModifiedBy: operatore.lastModifiedBy,
						lastModifiedDate: operatore.lastModifiedDate,
						telefono: operatore.telefono,
						indirizzo: operatore.indirizzo,
						prestazioniPreferitePuntoList: [],
						cooperativaName: operatore.cooperativaName,
						codiceFiscale: operatore.codiceFiscale,
						unificazioneAsl: operatore.unificazioneAsl
					})
					.then(res => {
						toast.success('Modifiche apportate con successo!');
						setOperatore(res.data);

						if (originalOperatore.login === auth.state.login) {
							auth.dispatch({
								type: 'UPDATE_CURRENT_USER', payload:
									{
										user: res.data
									}
							})
						}

						setOriginalOperatore(res.data);
						getPuntiServizio(res.data.id)
					})
					.catch(error => {
						toast.error('🛑 Errore durante il salvataggio dell\'operatore');
						console.log(error)
					})
			}
		}
	}

	const handleEliminaAccount = () => {
		setIsDelete(true);
		setModalMessage('Sei sicuro di voler procedere con la cancellazione?')
		setUserDeleteModalVisible(true);
	}

	const handleDisattivaAccount = () => {
		setIsDelete(false);
		setModalMessage('Sei sicuro di voler procedere con la disattivazione?')
		setUserDeleteModalVisible(true);
	}

	const handleCambioPassword = () => {
		setOpenCambioPassword(true);
	}

	const handleDialogCambioPasswordClose = (newPassword?: string) => {
		setOpenCambioPassword(false);
		if (newPassword) {
			const encodedPsw = btoa(newPassword);
			auth.state.axiosInstance?.post('/api/accounts/change-user-password', {id: operatore.id, newPassword: encodedPsw})
				.then(res => {
					toast.success("Password Modificata Correttamente!");
				})
				.catch(error => {
					toast.error('🛑 Errore durante la modifica della password');
					console.log(error);
					setOpenCambioPassword(true);
				});
		}
	}

	const closeUserDeleteModal = () => {
		setUserDeleteModalVisible(false);
	};

	const confirmUserDeleteModal = () => {
		setUserDeleteModalVisible(false);
		if (isDelete) {
			auth.state.axiosInstance?.delete('/api/accounts/delete/' + operatore.id)
				.then(res => {
					toast.success('Utente ' + operatore.login + ' eliminato con successo!');
					history.push('/operatori');
				})
				.catch(error => {
					if (406 === error.response.status) {
						alert.setAlertMessage(error.response.data.message);
						alert.setShowAlert(true);
					} else {
						toast.error('🛑 Errore durante la cancellazione dell\'operatore!');
					}
					console.log(error);
				});
		} else {
			auth.state.axiosInstance?.delete('/api/accounts/deactivate/' + operatore.id)
				.then(res => {
					toast.success('Utente ' + operatore.login + ' disattivato con successo!');
					history.push('/operatori');
				})
				.catch(error => {
					toast.error('🛑 Errore durante la disattivazione dell\'operatore!');
					console.log(error);
				});
		}
	};

	const handleAggiungiPunti = () => {
		setOpenDialogPunti(true);
	}

	const handleCloseDialogPunti = (selectedPunti?: string[]) => {
		setOpenDialogPunti(false);

		if (selectedPunti && selectedPunti.length > 0) {
			let ids = '';
			selectedPunti.forEach(id => ids += id + ',');
			ids = ids.substr(0, ids.length - 1);

			auth.state.axiosInstance?.put('/api/puntoServizio/update/add_punti_servizio_to_operatore/' + operatore.id + "/" + ids)
				.then(res => {
					setPuntiServizioList(res.data);
					setFilteredPuntiServizioList(res.data)
					setSelected([]);
				})
				.catch(error => {
					toast.error('🛑 Errore durante l\'aggiornamento dei Punti di Servizio!');
					console.log(error);
				});
		}
	};

	const handleEliminaPuntiSelezionati = () => {
		setDeleteModalVisible(true);
	}

	const closeDeleteModal = () => {
		setDeleteModalVisible(false);
	};

	const confirmDeleteModal = () => {
		setOpenDialogPunti(false);
		setDeleteModalVisible(false);

		if (selected && selected.length > 0) {
			let ids = '';
			selected.forEach(id => ids += id + ',');
			ids = ids.substr(0, ids.length - 1);
			auth.state.axiosInstance?.put('/api/puntoServizio/update/delete_punti_servizio_to_operatore/' + operatore.id + "/" + ids)
				.then(res => {
					setPuntiServizioList(res.data);
					setFilteredPuntiServizioList(res.data)
					setSelected([]);
				})
				.catch(error => {
					toast.error('🛑 Errore durante l\'aggiornamento dei Punti di Servizio!');
					console.log(error);
				});
		}
	};

	const handleCheckBoxClick = (event: React.MouseEvent<unknown>, id: string) => {
		const selectedIndex = selected.indexOf(id);
		let newSelected: string[] = [];

		if (selectedIndex === -1) {
			newSelected = newSelected.concat(selected, id);
		} else if (selectedIndex === 0) {
			newSelected = newSelected.concat(selected.slice(1));
		} else if (selectedIndex === selected.length - 1) {
			newSelected = newSelected.concat(selected.slice(0, -1));
		} else if (selectedIndex > 0) {
			newSelected = newSelected.concat(
				selected.slice(0, selectedIndex),
				selected.slice(selectedIndex + 1),
			);
		}
		setSelected(newSelected);
	}

	const handleRequestSort = (event: React.MouseEvent<unknown>, property: keyof PuntoServizioDTO) => {
		const isAsc = orderBy === property && order === 'asc';
		setOrder(isAsc ? 'desc' : 'asc');
		setOrderBy(property);
		setFilteredPuntiServizioList(filteredPuntiServizio());
	};

	const handleSelectAllClick = (event: React.ChangeEvent<HTMLInputElement>) => {
		if (event.target.checked) {
			const newSelecteds = puntiServizioList.map((n) => n.id);
			setSelected(newSelecteds);
			return;
		}
		setSelected([]);
	};

	const filteredPuntiServizio = (): PuntoServizioDTO[] => {
		let filtered = [...puntiServizioList];
		filtered = filtered.sort(comparator)
		return filtered
	}

	const comparator = (a: PuntoServizioDTO, b: PuntoServizioDTO): number => {
		if (a[orderBy] > b[orderBy]) {
			return order === 'desc' ? -1 : 1;
		}

		if (a[orderBy] < b[orderBy]) {
			return order === 'desc' ? 1 : -1;
		}

		return 0;
	}

	const handleGoBack = () => {
		// history.push('/operatori');
		history.goBack();
	}

	const isSelected = (name: string) => selected.indexOf(name) !== -1;

	return (
		<div>
			<STitleContainer>
				<STitleH3>{mode === PageMode.EDIT ? "Dettaglio operatore" : "Nuovo operatore"}</STitleH3>
			</STitleContainer>
			<Grid container spacing={0} className="w-100">
				<Grid item xs={3} className="pr-2">
					<TextField
						required
						className="w-100"
						id="nome"
						label="Nome"
						variant="outlined"
						InputLabelProps={{shrink: true}}
						value={operatore.firstname ? operatore.firstname : ''}
						onChange={handleNomeChange}
						error={errorFistName}
					/>
				</Grid>
				<Grid item xs={3} className="px-2">
					<TextField
						required
						className="w-100"
						id="cognome"
						label="Cognome"
						variant="outlined"
						InputLabelProps={{shrink: true}}
						value={operatore.lastname ? operatore.lastname : ''}
						onChange={handleCognomeChange}
						error={errorLastName}
					/>
				</Grid>
				<Grid item xs={3} className="px-2">
					<TextField
						required
						className="w-100"
						id="login"
						label="Login"
						variant="outlined"
						helperText={errorDuplicatedLogin && "Login già utilizzato"}
						InputLabelProps={{shrink: true}}
						value={operatore.login ? operatore.login : ''}
						onChange={handleLoginChange}
						error={errorLogin || errorDuplicatedLogin}
					/>
				</Grid>
				<Grid item xs={3} className="pl-2">
					<TextField
						className="w-100"
						id="telefono"
						label="Telefono"
						variant="outlined"
						InputLabelProps={{shrink: true}}
						value={operatore.telefono ? operatore.telefono : ''}
						onChange={handleTelefonoChange}
					/>
				</Grid>
			</Grid>
			<Grid container spacing={0} className="w-100 mt-3">
				<Grid item xs={3} className="pr-2">
					<TextField
						className="w-100"
						id="indirizzo"
						label="Indirizzo"
						variant="outlined"
						InputLabelProps={{shrink: true}}
						value={operatore.indirizzo ? operatore.indirizzo : ''}
						onChange={handleIndirizzoChange}
					/>
				</Grid>
				<Grid item xs={3} className="px-2">
					<TextField
						required
						className="w-100"
						id="email"
						label="Email"
						variant="outlined"
						helperText={errorValidEmail ? "Formato email non corretto" : ''}
						InputLabelProps={{shrink: true}}
						value={operatore.email ? operatore.email : ''}
						onChange={handleEmailChange}
						error={errorValidEmail || errorEmail}
					/>
				</Grid>
				<Grid item xs={3} className="px-2">
					<FormControl required variant="outlined" className={classes.formControl} error={errorAuth}>
						<SInputLabel id="canaleAccesso">Ruolo</SInputLabel>
						<Select
							required
							labelId="role"
							id="roleSelect"
							multiple
							className={classes.selectEmpty}
							label="Ruolo"
							value={operatore.authorities}
							renderValue={(selected) => getRolesPrettyName(selected as string[])}
							onChange={handleRuoloChange}
							MenuProps={{
								anchorOrigin: {
									vertical: "bottom",
									horizontal: "left"
								},
								transformOrigin: {
									vertical: "top",
									horizontal: "left"
								},
								getContentAnchorEl: null
							}}
						>
							<MenuItem value={UserRole.SUPERVISOR} key={UserRole.SUPERVISOR}>
								<SCheckbox checked={operatore.authorities.indexOf(UserRole.SUPERVISOR) > -1}/>
								{UserRolePrettyName.SUPERVISOR}
							</MenuItem>
							<MenuItem value={UserRole.RESPONSIBLE} key={UserRole.RESPONSIBLE}>
								<SCheckbox checked={operatore.authorities.indexOf(UserRole.RESPONSIBLE) > -1}/>
								{UserRolePrettyName.RESPONSIBLE}
							</MenuItem>
							<MenuItem value={UserRole.OPERATOR} key={UserRolePrettyName.OPERATOR}>
								<SCheckbox checked={operatore.authorities.indexOf(UserRole.OPERATOR) > -1}/>
								{UserRolePrettyName.OPERATOR}
							</MenuItem>
							{auth.state.roles && auth.state.roles.indexOf(UserRole.ADMIN) >= 0 &&
								<MenuItem value={UserRole.UNIFICATORE} key={UserRolePrettyName.UNIFICATORE}>
								<SCheckbox checked={operatore.authorities.indexOf(UserRole.UNIFICATORE) > -1}/>
							{UserRolePrettyName.UNIFICATORE}
								</MenuItem>
							}
							{auth.state.roles && auth.state.roles.indexOf(UserRole.ADMIN) >= 0 &&
								<MenuItem value={UserRole.REPORT} key={UserRole.REPORT}>
									<SCheckbox checked={operatore.authorities.indexOf(UserRole.REPORT) > -1}/>
									{UserRolePrettyName.REPORT}
								</MenuItem>
							}
						</Select>
					</FormControl>
				</Grid>
				<Grid item xs={3} className="pl-2">
					<TextField
						className="w-100"
						id="codiceFiscale"
						label="Codice Fiscale"
						variant="outlined"
						value={operatore.codiceFiscale}
						onChange={handleCodiceFiscaleChange}
						error={errorCodiceFiscale}
						helperText={errorCodiceFiscale && "Codice Fiscale non valido"}
						InputLabelProps={{shrink: true}}
						inputProps={{style: {textTransform: "uppercase"}}}
						required={operatore.authorities.indexOf(UserRole.OPERATOR) >= 0
							|| operatore.authorities.indexOf(UserRole.RESPONSIBLE) >= 0
							|| operatore.authorities.indexOf(UserRole.SUPERVISOR) >= 0}
					/>
				</Grid>
			</Grid>
			{auth.state.roles && auth.state.roles.indexOf(UserRole.ADMIN) >= 0 &&
			<Grid container spacing={0} className="w-100 mt-3">
				<Grid item xs={3} className="pr-2">
					<FormControl variant="outlined" className={classes.formControl}>
						<SInputLabel id="cooperativa">Cooperativa</SInputLabel>
						<Select
							required
							labelId="cooperativa"
							id="cooperativaSelect"
							className={classes.selectEmpty}
							label="Cooperativa"
							value={operatore.cooperativa}
							onChange={handleCooperativaChange}
							MenuProps={{
								anchorOrigin: {
									vertical: "bottom",
									horizontal: "left"
								},
								transformOrigin: {
									vertical: "top",
									horizontal: "left"
								},
								getContentAnchorEl: null
							}}
						>
							{cooperativeList && cooperativeList.map(op => {
								return (
									<MenuItem value={op.id} key={op.id}>{op.name}</MenuItem>
								)
							})}
						</Select>
					</FormControl>
				</Grid>

				{operatore.authorities && operatore.authorities.indexOf(UserRole.UNIFICATORE) >= 0 &&
					<Grid item xs={3} className="pr-2">
						<FormControl required variant="outlined" className={classes.formControl} error={errorCupUnico}>
							<SInputLabel id="unificazioneAsl">Unificazioni ASL</SInputLabel>
							<Select
								required
								labelId="unificazioneAsl"
								id="unificazioneAslSelect"
								className={classes.selectEmpty}
								label="unificazioneAsl"
								value={operatore.unificazioneAsl}
								onChange={handleUnificazioneAslChange}
								MenuProps={{
									anchorOrigin: {
										vertical: "bottom",
										horizontal: "left"
									},
									transformOrigin: {
										vertical: "top",
										horizontal: "left"
									},
									getContentAnchorEl: null
								}}
							>
								{unificazioneAslList && unificazioneAslList.map(op => {
									return (
										<MenuItem value={op.id} key={op.id}>{op.name}</MenuItem>
									)
								})}
							</Select>
						</FormControl>
					</Grid>
				}
			</Grid>
			}
			{mode === PageMode.NEW &&
			<Grid container spacing={0} className="w-100 mt-3">
				<Grid item xs={3} className="pr-2">
					<TextField
						required
						className="w-100"
						id="password"
						label="Password"
						variant="outlined"
						type="password"
						InputLabelProps={{shrink: true}}
						inputProps={{
							autocomplete: 'new-password',
							form: {
								autocomplete: 'off',
							},
						}}
						value={password}
						onChange={handlePasswordChange}
						error={errorPass}
					/>
				</Grid>
				<Grid item xs={3} className="pr-2">
					<TextField
						required
						className="w-100"
						id="repeatPassword"
						label="Ripeti Password"
						variant="outlined"
						type="password"
						InputLabelProps={{shrink: true}}
						value={repeatNewPassword}
						onChange={handleRepeatPasswordChange}
						error={errorRepeat}
						helperText={errorRepeat && "Le due password devono corrispondere"}
					/>
				</Grid>
			</Grid>
			}
			<Grid container spacing={0} className="w-100 mt-3">
				<Grid item xs={12} className="d-flex align-items-center justify-content-end">
					<SButton disabled={errorDuplicatedLogin} onClick={handleSaveOperatore}>Salva</SButton>
					{mode === PageMode.EDIT && originalOperatore && originalOperatore.login !== '' && auth &&
						<React.Fragment>
							{
								originalOperatore.login !== auth.state.login &&
								<>
									<SButton variant="arancio" onClick={handleDisattivaAccount}>Disattiva Account</SButton>
									<SButton variant="rosso" onClick={handleEliminaAccount}>Elimina Account</SButton>
								</>
							}
							{
								(originalOperatore.login === auth.state.login
									|| (auth.state.roles && auth.state.roles.indexOf(UserRole.SUPERVISOR) > -1 && originalOperatore.authorities.indexOf(UserRole.ADMIN) < 0)
									|| (auth.state.roles && auth.state.roles.indexOf(UserRole.ADMIN) > -1))
								&&
								<SDialogButton className="font-18" onClick={handleCambioPassword}>Modifica Password</SDialogButton>
							}
						</React.Fragment>
					}
				</Grid>
			</Grid>
			{mode === PageMode.EDIT &&
			<SPanelContainer>
				<STitleH4> PUNTI DI SERVIZIO ASSOCIATI ALL'OPERATORE </STitleH4>
				<SButtonContainer>
					<SButton onClick={handleAggiungiPunti}><RiAddFill className="mr-2"/>Aggiungi</SButton>
					<SButton onClick={handleEliminaPuntiSelezionati} variant="rosso" disabled={!selected || selected.length === 0}><FaTrash className="mr-2"/>Elimina</SButton>
				</SButtonContainer>
				<TableContainer className="max-height-table">
					<Table
						aria-labelledby="tableTitle"
						size={'medium'}
						aria-label="enhanced table"
					>
						<PuntiServizioTableHeader
							numSelected={selected.length}
							order={order}
							orderBy={orderBy}
							onSelectAllClick={handleSelectAllClick}
							onRequestSort={handleRequestSort}
							rowCount={filteredPuntiServizio().length}
							headCells={headCells}
							addCheckbox={true}
							bgcolor="primary"
							sortable={true}
							disableAction={false}
						/>
						<TableBody>
							{filteredPuntiServizioList &&
								filteredPuntiServizioList
									.map((row, index) => {
										const isItemSelected = isSelected(row.id);
										const labelId = `enhanced-table-checkbox-${index}`;

										return (
											<STableRow
												hover
												role="checkbox"
												aria-checked={isItemSelected}
												tabIndex={-1}
												key={row.id}
												selected={isItemSelected}
											>
												<STableCell padding="checkbox">
													<SCheckbox
														checked={isItemSelected}
														inputProps={{'aria-labelledby': labelId}}
														onClick={(event) => handleCheckBoxClick(event, row.id)}
													/>
												</STableCell>
												<STableCell padding="none">{row.name}</STableCell>
												<STableCell padding="none">{row.cooperativaName}</STableCell>
												<STableCell padding="none">{row.asl}</STableCell>
												<STableCell padding="none">{row.indirizzo}</STableCell>
												<STableCell padding="none">{row.operatori?.length}</STableCell>
											</STableRow>
										);
									})}
						</TableBody>
					</Table>
				</TableContainer>
				<ConfirmAlertDialog
					open={deleteModalVisible}
					onCancel={closeDeleteModal}
					onConfirm={confirmDeleteModal}
					message={'Sei sicuro di voler procedere con la cancellazione?'}
				/>
				<ConfirmAlertDialog
					open={deleteUserModalVisible}
					onCancel={closeUserDeleteModal}
					onConfirm={confirmUserDeleteModal}
					message={modalMessage}
				/>
				<InserimentoPuntiServizioDialog
					open={openDialogPunti}
					onClose={handleCloseDialogPunti}
					alreadyAssociated={puntiServizioList}
					cooperativa={operatore.cooperativa}/>
				<CambioPasswordDialog open={openCambioPassword} onClose={handleDialogCambioPasswordClose} canClose={true} userId={operatore.id}/>
			</SPanelContainer>
			}
			<SButtonContainer>
				<SButton onClick={handleGoBack}><FaChevronLeft/>Torna indietro</SButton>
			</SButtonContainer>
		</div>
	);
}
